/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$getPrototypeOf = _interopDefault(require('babel-runtime/core-js/object/get-prototype-of'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _get = _interopDefault(require('babel-runtime/helpers/get'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var __ol__ = _interopDefault(require('openlayers'));
var minilo = require('../util/minilo');
var consts = require('./consts');
var geom = require('./geom');
var proj = require('./proj');
var util = require('./util');

/**
 * @param {olx.format.GeoJSONOptions} [options]
 * @return {ol.format.GeoJSON}
 */
var BaseGeoJSON = __ol__.format.GeoJSON;
var TopoJSON = __ol__.format.TopoJSON;
var MVT = __ol__.format.MVT;
function createGeoJsonFmt(options) {
  return new GeoJSON(options);
}

/**
 * @param {olx.format.TopoJSONOptions} [options]
 * @return {ol.format.TopoJSON}
 */
function createTopoJsonFmt(options) {
  return new TopoJSON(options);
}

/**
 * @param [options]
 * @return {ol.format.MVT}
 */
function createMvtFmt(options) {
  return new MVT(options);
}

var GeoJSON = function (_BaseGeoJSON) {
  _inherits(GeoJSON, _BaseGeoJSON);

  function GeoJSON() {
    _classCallCheck(this, GeoJSON);

    return _possibleConstructorReturn(this, (GeoJSON.__proto__ || _Object$getPrototypeOf(GeoJSON)).apply(this, arguments));
  }

  _createClass(GeoJSON, [{
    key: 'writeGeometryObject',
    value: function writeGeometryObject(geometry, options) {
      if (util.isCircle(geometry)) {
        geometry = geom.createCircularPolygon(proj.transformPoint(geometry.getCenter(), options.featureProjection || this.defaultFeatureProjection, consts.EPSG_4326), geometry.getRadius());
        options.featureProjection = consts.EPSG_4326;
      }
      return _get(GeoJSON.prototype.__proto__ || _Object$getPrototypeOf(GeoJSON.prototype), 'writeGeometryObject', this).call(this, geometry, options);
    }
  }, {
    key: 'writeFeatureObject',
    value: function writeFeatureObject(feature, options) {
      var object = /** @type {GeoJSONFeature} */{
        'type': 'Feature'
      };
      var id = feature.getId();
      if (id !== undefined) {
        object.id = id;
      }
      var geometry = feature.getGeometry();
      if (geometry) {
        object.geometry = this.writeGeometryObject(geometry, options);
      } else {
        object.geometry = null;
      }
      var properties = feature.getProperties();
      delete properties[feature.getGeometryName()];
      if (!minilo.isEmpty(properties)) {
        object.properties = properties;
      } else {
        object.properties = null;
      }
      return object;
    }
  }]);

  return GeoJSON;
}(BaseGeoJSON);

exports.createGeoJsonFmt = createGeoJsonFmt;
exports.createTopoJsonFmt = createTopoJsonFmt;
exports.createMvtFmt = createMvtFmt;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/format.js
// module id = 242
// module chunks = 1